import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Menu from "./menu/Menu";

class MenuDASHBOARD extends React.Component {
  render() {
    let menuItems = [
      {
        link: "/home/clients/",
        formattedMessageId: "Clients",
      },
      {
        link: "/home/imagedatabase/",
        formattedMessageId: "Image.Database",
      },
      {
        link: "/home/stats/",
        formattedMessageId: "Stats",
      },
    ];

    let menuItemLogo = {
      imgSrc: "./images/svg/logo_v2_cut.svg",
      imgAlt: "logo pharma-mad",
    };

    return (
      <React.Fragment>
        <Menu menuItems={menuItems} menuItemLogo={menuItemLogo} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuDASHBOARD),
);
